<template>
  <div class="voucher-empty-state">
    <div class="illustration-container">
      <img :src="require('@/assets/voucher-empty.svg')" alt="Ilustração de programa de pontos" class="illustration" />
    </div>
    <div class="content-container">
      <h2 class="title">Seu programa de pontos ainda não tem recompensas ativas</h2>
      <p class="description">
        Sem recompensas, os clientes acumulam pontos, mas não têm como usá-los – e isso pode desanimar. Cadastre ao menos um vale-troca para manter o
        engajamento.
      </p>
      <mf-button label="Novo vale-troca" icon="add" icon-position="left" @click="createNewVoucher" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'VoucherEmptyState',
  methods: {
    createNewVoucher() {
      this.$router.push('/mobile/pontos/novo')
    },
  },
}
</script>

<style lang="scss" scoped>
.voucher-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 16px;
  text-align: center;
  border-radius: 8px;
}

.illustration-container {
  margin-bottom: 32px;

  .illustration {
    width: 520px;
  }
}

.content-container {
  max-width: 620px;

  .title {
    font-size: 22px;
    font-weight: 700;
    color: #4b525a;
    margin-bottom: 16px;
  }

  .description {
    font-size: 16px;
    color: #4b525a;
    margin-bottom: 32px;
    letter-spacing: 0.4px;
  }
}

@media (max-width: 768px) {
  .voucher-empty-state {
    padding: 16px;
  }

  .illustration-container {
    margin-bottom: 24px;

    .illustration {
      width: 280px;
    }
  }

  .content-container {
    .title {
      font-size: 20px;
    }

    .description {
      font-size: 14px;
    }
  }
}
</style>
